import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const handoffConversationToSupport = {
  name: "handoffConversationToSupport" as const,
  input: z.object({ conversationId: zExt.objectId() }),
  output: z.object({
    success: z.boolean(),
    errorMessage: z.string().optional(),
  }),
};
